<div class="wrap">
  <header>
    <label for="slide-1-trigger">اسلاید اول</label>
    <label for="slide-2-trigger">اسلاید دوم</label>
    <label for="slide-3-trigger">اسلاید سوم</label>
    <label for="slide-4-trigger">اسلاید چهارم</label>
  </header>
  <input id="slide-1-trigger" type="radio" name="slides" checked>
  <section class="slide slide-one">
    <h1>عنوان تستی</h1>
    <p class="mt-5" style="color: black; background: white">
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه
      روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود
      ابزارهای کاربردی می باشد.
    </p>
  </section>
  <input id="slide-2-trigger" type="radio" name="slides">
  <section class="slide slide-two">
    <h1>عنوان تستی</h1>
    <p class="mt-5" style="color: black; background: white">
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه
      روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود
      ابزارهای کاربردی می باشد.
    </p>
  </section>
  <input id="slide-3-trigger" type="radio" name="slides">
  <section class="slide slide-three">
    <h1>عنوان تستی</h1>
    <p class="mt-5" style="color: black; background: white">
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه
      روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود
      ابزارهای کاربردی می باشد.
    </p>
  </section>
  <input id="slide-4-trigger" type="radio" name="slides">
  <section class="slide slide-four">
    <h1>عنوان تستی</h1>
    <p class="mt-5" style="color: black; background: white">
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه
      روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود
      ابزارهای کاربردی می باشد.
    </p>
  </section>
</div>
